import { Injectable } from '@angular/core';
import { StorageService } from "./storage.service";
import { catchError, finalize, of } from "rxjs";
import { Router } from "@angular/router";
import { HttpService } from "@app/core/services/http.service";

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  constructor(
    private storageService: StorageService,
    private router: Router,
    private httpService: HttpService,

  ) { }

  onLogout(): void {
    this.httpService.logout().pipe(
      catchError(() => {
        return of(null);
      }),
      finalize(() => {
        this.storageService.removeToken();
        const currentUrl = window.location.pathname + window.location.search + window.location.hash;
        localStorage.setItem('originalPageUrl', currentUrl);
        this.router.navigate(['/auth/login']).then(r => r);
      })
    ).subscribe();
  }



}
